var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlyssia1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170.4 319.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-4, .cls-5, .cls-7 {\n        stroke-linecap: round;\n      }\n\n      .cls-1, .cls-2, .cls-5 {\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-7 {\n        stroke-width: 2.8px;\n      }\n\n      .cls-1, .cls-7, .cls-9 {\n        stroke: #000;\n      }\n\n      .cls-10 {\n        fill: #6e2f22;\n      }\n\n      .cls-11 {\n        fill: #e296cf;\n      }\n\n      .cls-2 {\n        stroke: #6e2f22;\n        stroke-width: 4px;\n      }\n\n      .cls-12 {\n        fill: #260809;\n      }\n\n      .cls-3 {\n        stroke: #000d19;\n      }\n\n      .cls-3, .cls-4, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3, .cls-6 {\n        stroke-width: 3.8px;\n      }\n\n      .cls-13 {\n        opacity: .5;\n      }\n\n      .cls-13, .cls-14 {\n        fill: #fff;\n      }\n\n      .cls-15 {\n        fill: #4d65b4;\n      }\n\n      .cls-16 {\n        fill: #aa3d74;\n        opacity: .4;\n      }\n\n      .cls-17 {\n        fill: #4d1417;\n      }\n\n      .cls-18 {\n        fill: #b7c8d8;\n      }\n\n      .cls-4 {\n        stroke: #f5c13d;\n        stroke-width: 3.1px;\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-21 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-22 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-23 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-24 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-25 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-26 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-27 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-28 {\n        fill: #e6eef2;\n      }\n\n      .cls-29 {\n        fill: #7bd2e8;\n      }\n\n      .cls-30 {\n        fill: #ffd24a;\n      }\n\n      .cls-31 {\n        fill: #8c432b;\n      }\n\n      .cls-5 {\n        stroke: #fff;\n        stroke-width: 11px;\n      }\n\n      .cls-32 {\n        fill: #eb175a;\n      }\n\n      .cls-33 {\n        fill: #000d19;\n      }\n\n      .cls-34 {\n        fill: #8695b2;\n      }\n\n      .cls-35 {\n        fill: #4d9be6;\n      }\n\n      .cls-36 {\n        fill: #073f4a;\n      }\n\n      .cls-37 {\n        fill: #ffae4a;\n      }\n\n      .cls-6 {\n        stroke: #b7c8d8;\n      }\n\n      .cls-38 {\n        fill: #8f005d;\n      }\n\n      .cls-39 {\n        fill: #360b0e;\n      }\n\n      .cls-8 {\n        stroke: #d99037;\n        stroke-width: 2px;\n      }\n\n      .cls-40 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-41 {\n        fill: #002131;\n      }\n\n      .cls-9 {\n        stroke-width: 3px;\n      }\n\n      .cls-42 {\n        fill: #033040;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 72.1,
    y: 63,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 111.7,
    y: 63,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1457,
    y: 67.3,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1496.6,
    y: 67.3,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 760.9,
    y: 66.6,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5,
    transform: "translate(14 -86.1) rotate(6.4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 800.3,
    y: 71,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5,
    transform: "translate(14.8 -90.5) rotate(6.4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M857.8,119.8l-1-1c-.6-.6-1.6-.6-2.2,0l-2.5,2.5-20,20c-.5.5-.9,1.1-1.1,1.8l-2.2,6.2,3.5,3.5,2.1-2.1,20.9-20.9,2.8-8c.2-.7,0-1.4-.4-1.9Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "856.2 127.8 853.3 124.9 849.7 128.5 828.9 149.3 817.7 181.2 820.6 184.1 822.7 181.9 845 159.7 856.2 127.8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "820.6 176.7 830.5 148.8 850.4 128.9 840.5 156.8 820.6 176.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M845,159.7l-2.9-2.9-3.6,3.6-20.8,20.8-1.4,3.9c-.4,1.1-.1,2.4.7,3.2h0c1.2,1.2,3.1,1.2,4.3,0h0s19.1-19.1,19.1-19.1c1.2-1.2,2.1-2.6,2.6-4.2l1.9-5.4Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "alyssia"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 736.3,
    cy: 23.7,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 749.9,
    cy: 17,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 725.9,
    cy: 31.9,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 717.7,
    cy: 41.8,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 710.4,
    cy: 52.5,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 706.7,
    cy: 65.4,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 704.1,
    cy: 78.7,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 702.7,
    cy: 91.7,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 702.8,
    cy: 103.5,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 823.1,
    cy: 33.5,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 811.3,
    cy: 23.9,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 831.3,
    cy: 43.8,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 837.2,
    cy: 55.3,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 841.9,
    cy: 67.3,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 842.6,
    cy: 80.8,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 842.1,
    cy: 94.3,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 840.6,
    cy: 107.3,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 837.9,
    cy: 118.8,
    r: 10.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M774.4,7.7h0c40.9,0,74.1,33.2,74.1,74.1v19.2c0,12.2-9.9,22.1-22.1,22.1h-104c-12.2,0-22.1-9.9-22.1-22.1v-19.2c0-40.9,33.2-74.1,74.1-74.1Z",
    transform: "translate(12.2 -86.5) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M101.5,294c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M91.7,281.8h32.9c2.4,0,4.4,2,4.4,4.4v14.1h-31c-6.2,0-11.3-5.1-11.3-11.3v-2.1c0-2.8,2.2-5,5-5Z",
    transform: "translate(215.6 582) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 100.7,
    y: 208.2,
    width: 17.6,
    height: 14,
    transform: "translate(218.9 430.4) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M109.4,188.5c6.8,0,12.4-5.5,12.4-12.4v-28.7c0-6.8-5.5-12.4-12.4-12.4-6.8,0-12.4,5.5-12.4,12.4v28.7c0,6.8,5.5,12.4,12.4,12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M97.1,176.5v30.4c0,1.8,1.5,3.2,3.2,3.2h18.2c1.8,0,3.2-1.5,3.2-3.2v-30.8c0-7-5.9-12.7-13-12.3s-11.8,6-11.8,12.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 114.6,
    cy: 222.2,
    r: 14
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 86.7,
    y: 269.7,
    width: 29.7,
    height: 22.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M75.5,262.6c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M75.5,307.5c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M101.5,249.1c-7.2,0-13-5.8-13-13v-32c0-7.2,5.8-13,13-13s13,5.8,13,13v32c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M81.9,183.8h13.1c10.7,0,19.4,8.7,19.4,19.4v8.1h-52v-8.1c0-10.7,8.7-19.4,19.4-19.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M90.6,191.6h4.3v9.5c0,2.4-1.9,4.3-4.3,4.3h0v-13.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M71.6,137.6h29.5c7,0,12.6,5.7,12.6,12.6v30.9c0,4.6-3.7,8.3-8.3,8.3h-38.1c-4.6,0-8.3-3.7-8.3-8.3v-30.9c0-7,5.7-12.6,12.6-12.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 75.3,
    y: 123.7,
    width: 22.7,
    height: 16.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M72.1,125.2h29.1c2.4,0,4.4,2,4.4,4.4v12.7h-37.8v-12.7c0-2.4,2-4.4,4.4-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M65.7,295.3h32.9c2.4,0,4.4,2,4.4,4.4v14.1h-31c-6.2,0-11.3-5.1-11.3-11.3v-2.1c0-2.8,2.2-5,5-5Z",
    transform: "translate(163.6 609.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 60.7,
    y: 283.2,
    width: 29.7,
    height: 22.5,
    transform: "translate(151 588.9) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 41.2,
    cy: 24.3,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 54,
    cy: 16.2,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 31.9,
    cy: 33.7,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 24.8,
    cy: 44.4,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 18.7,
    cy: 55.9,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 16.5,
    cy: 69.2,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 15.5,
    cy: 82.6,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 15.5,
    cy: 95.7,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 16.9,
    cy: 107.4,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 128.6,
    cy: 24.3,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 115.8,
    cy: 16.2,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 138,
    cy: 33.7,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 145,
    cy: 44.4,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 151.1,
    cy: 55.9,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 153.3,
    cy: 69.2,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 154.3,
    cy: 82.6,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 154.3,
    cy: 95.7,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 152.9,
    cy: 107.4,
    r: 10.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M83.8,3.9h0c40.9,0,74.1,33.2,74.1,74.1v19.2c0,12.2-9.9,22.1-22.1,22.1H31.8c-12.2,0-22.1-9.9-22.1-22.1v-19.2C9.7,37.1,42.9,3.9,83.8,3.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 137.7,
    cy: 77.9,
    r: 14.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 47.2,
    cy: 77.9,
    r: 14.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M80.1-.8h13.4c23.7,0,43,19.3,43,43v24.6c0,5.9-4.8,10.7-10.7,10.7H47.7c-5.9,0-10.7-4.8-10.7-10.7v-24.6C37.1,18.5,56.3-.8,80.1-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M138.8,86.5c6.4,0,11.5,5.2,11.5,11.5s-5.2,11.5-11.5,11.5-11.5-5.2-11.5-11.5,1-5.4,2.7-7.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M47.2,86.5c-6.4,0-11.5,5.2-11.5,11.5s5.2,11.5,11.5,11.5c6.4,0,11.5-5.2,11.5-11.5,0-2.8-1-5.4-2.7-7.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M79.8,36.1h25.8c15.7,0,28.4,12.7,28.4,28.4v23c0,21.7-17.6,39.4-39.4,39.4h-3.8c-21.7,0-39.4-17.6-39.4-39.4v-23c0-15.7,12.7-28.4,28.4-28.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M110.4,106.3c1.8,0,3,1.9,2.1,3.5-2.5,4.5-7.2,7.6-12.8,7.6s-10.3-3.1-12.8-7.6.3-3.5,2.1-3.5h21.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 72.1,
    y: 63,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 79.9,
    y: 71.4,
    width: 11.7,
    height: 19.6,
    rx: 5.8,
    ry: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 79,
    y: 68.3,
    width: 6.4,
    height: 11.7,
    rx: 3.2,
    ry: 3.2
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M72.1,73.8v-.2c0-5.8,4.7-10.5,10.5-10.5h0c5.8,0,10.5,4.7,10.5,10.5v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 68.6,
    y1: 70.2,
    x2: 72.3,
    y2: 71.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 70,
    y1: 66.2,
    x2: 73.5,
    y2: 68
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M67.7,85.8h0c7.2,0,13,5.8,13,13v2.3h-11.4c-3.6,0-6.6-3-6.6-6.6v-3.7c0-2.7,2.2-5,5-5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 68,
    cy: 97.9,
    r: 7.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 111.7,
    y: 63,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 118.9,
    y: 71.4,
    width: 11.7,
    height: 19.6,
    rx: 5.8,
    ry: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 118,
    y: 68.3,
    width: 6.4,
    height: 11.7,
    rx: 3.2,
    ry: 3.2
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M132.8,73.8v-.2c0-5.8-4.7-10.5-10.5-10.5h0c-5.8,0-10.5,4.7-10.5,10.5v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 136.3,
    y1: 70.2,
    x2: 132.5,
    y2: 71.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 134.9,
    y1: 66.2,
    x2: 131.4,
    y2: 68
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M128.2,85.8h7.7v3.8c0,6.4-5.2,11.5-11.5,11.5h0v-11.5c0-2.1,1.7-3.9,3.9-3.9Z",
    transform: "translate(260.1 186.9) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 133.7,
    cy: 97,
    r: 7.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M115.5,70h17.6c4.1,0,7.4,3.3,7.4,7.4v3.4c0,7.9-6.4,14.4-14.4,14.4h-3.7c-7.9,0-14.4-6.4-14.4-14.4v-3.4c0-4.1,3.3-7.4,7.4-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M72.6,70h17.6c4.1,0,7.4,3.3,7.4,7.4v3.4c0,7.9-6.4,14.4-14.4,14.4h-3.7c-7.9,0-14.4-6.4-14.4-14.4v-3.4c0-4.1,3.3-7.4,7.4-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M97.6,79.5s1.3-2.8,5.2-2.8,5.2,3.1,5.2,3.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M102.9,81.2v15.3c0,2.2,1.8,4,4,4h2.4c3,0,5-3.2,3.6-5.9l-7.2-14.1c-.7-1.4-2.8-.9-2.8.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M59.9,38.9h0v86.8c0,1.6-1.3,2.9-2.9,2.9h0c-8.8,0-15.9-7.1-15.9-15.9v-55.1c0-10.3,8.4-18.7,18.7-18.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 62.5,
    cy: 47,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 61.8,
    cy: 42.1,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 69.1,
    cy: 40.1,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 78.9,
    cy: 35.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 58.4,
    cy: 56.9,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 58.4,
    cy: 67,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 58.4,
    cy: 76.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 58.4,
    cy: 103.6,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 58.4,
    cy: 112.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 58.4,
    cy: 122,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 58.4,
    cy: 85.3,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 58.4,
    cy: 94.5,
    r: 6.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M148.2,36.9h0c1.6,0,2.9,1.3,2.9,2.9v86.8h0c-10.3,0-18.7-8.4-18.7-18.7v-55.1c0-8.8,7.1-15.9,15.9-15.9Z",
    transform: "translate(283.4 163.5) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 131.4,
    cy: 45.1,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 124.7,
    cy: 38.1,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 115,
    cy: 33.3,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 135.5,
    cy: 54.9,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 135.5,
    cy: 65,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 135.5,
    cy: 74.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 135.5,
    cy: 101.7,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 135.5,
    cy: 110.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 135.5,
    cy: 120,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 135.5,
    cy: 83.3,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 135.5,
    cy: 92.5,
    r: 6.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 51.6,
    y: 221.1,
    width: 17.6,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M60.4,201.4c-6.8,0-12.4-5.5-12.4-12.4v-28.7c0-6.8,5.5-12.4,12.4-12.4s12.4,5.5,12.4,12.4v28.7c0,6.8-5.5,12.4-12.4,12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M72.8,189.4v30.4c0,1.8-1.5,3.2-3.2,3.2h-18.2c-1.8,0-3.2-1.5-3.2-3.2v-30.8c0-7,5.9-12.7,13-12.3,6.6.3,11.8,6,11.8,12.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 55.2,
    cy: 235.1,
    r: 14
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 88.5,
    y1: 211.7,
    x2: 88.5,
    y2: 280.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1486.4,294c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1476.6,281.8h32.9c2.4,0,4.4,2,4.4,4.4v14.1h-31c-6.2,0-11.3-5.1-11.3-11.3v-2.1c0-2.8,2.2-5,5-5Z",
    transform: "translate(2985.4 582) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 1539.6,
    y: 144,
    width: 17.6,
    height: 14,
    transform: "translate(1086.5 -1334.6) rotate(67.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1521.1,174.8c4.8-4.8,4.8-12.7,0-17.5l-20.3-20.3c-4.8-4.8-12.7-4.8-17.5,0-4.8,4.8-4.8,12.7,0,17.5l20.3,20.3c4.8,4.8,12.7,4.8,17.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1517.5,177.4l28-11.8c1.7-.7,2.4-2.6,1.7-4.3l-7.1-16.8c-.7-1.7-2.6-2.4-4.3-1.7l-28.4,11.9c-6.5,2.7-9.4,10.3-6.3,16.7,2.9,6,10.1,8.5,16.3,5.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 1552.8,
    cy: 143.5,
    r: 14
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 1471.6,
    y: 269.7,
    width: 29.7,
    height: 22.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1460.4,262.6c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1460.4,307.5c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1486.4,249.1c-7.2,0-13-5.8-13-13v-32c0-7.2,5.8-13,13-13s13,5.8,13,13v32c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1466.8,183.8h13.1c10.7,0,19.4,8.7,19.4,19.4v8.1h-52v-8.1c0-10.7,8.7-19.4,19.4-19.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1475.5,191.6h4.3v9.5c0,2.4-1.9,4.3-4.3,4.3h0v-13.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1456.5,137.6h29.5c7,0,12.6,5.7,12.6,12.6v30.9c0,4.6-3.7,8.3-8.3,8.3h-38.1c-4.6,0-8.3-3.7-8.3-8.3v-30.9c0-7,5.7-12.6,12.6-12.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 1460.2,
    y: 123.7,
    width: 22.7,
    height: 16.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1456.7,131.7h29.1c2.4,0,4.4,2,4.4,4.4v6.4h-37.8v-6.4c0-2.4,2-4.4,4.4-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1450.6,295.3h32.9c2.4,0,4.4,2,4.4,4.4v14.1h-31c-6.2,0-11.3-5.1-11.3-11.3v-2.1c0-2.8,2.2-5,5-5Z",
    transform: "translate(2933.4 609.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 1445.6,
    y: 283.2,
    width: 29.7,
    height: 22.5,
    transform: "translate(2920.8 588.9) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1426.1,
    cy: 28.7,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1438.9,
    cy: 20.5,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1416.7,
    cy: 38.1,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1409.7,
    cy: 48.8,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1403.6,
    cy: 60.2,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1401.4,
    cy: 73.6,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1400.4,
    cy: 87,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1400.4,
    cy: 100.1,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1401.8,
    cy: 111.8,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1513.5,
    cy: 28.7,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1500.7,
    cy: 20.5,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1522.8,
    cy: 38.1,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1529.9,
    cy: 48.8,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1536,
    cy: 60.2,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1538.2,
    cy: 73.6,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1539.2,
    cy: 87,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1539.2,
    cy: 100.1,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1537.8,
    cy: 111.8,
    r: 10.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1468.7,8.3h0c40.9,0,74.1,33.2,74.1,74.1v19.2c0,12.2-9.9,22.1-22.1,22.1h-104c-12.2,0-22.1-9.9-22.1-22.1v-19.2c0-40.9,33.2-74.1,74.1-74.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 1522.5,
    cy: 82.3,
    r: 14.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 1432.1,
    cy: 82.3,
    r: 14.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1465,3.6h13.4c23.7,0,43,19.3,43,43v24.6c0,5.9-4.8,10.7-10.7,10.7h-78c-5.9,0-10.7-4.8-10.7-10.7v-24.6c0-23.7,19.3-43,43-43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1523.7,90.9c6.4,0,11.5,5.2,11.5,11.5s-5.2,11.5-11.5,11.5-11.5-5.2-11.5-11.5,1-5.4,2.7-7.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1543.1,72c0-7.1-5.8-12.9-12.9-12.9h-12.1c-3.3,0-6.3,1.2-8.5,3.3h0s-.2.2-.2.2c-.3.2-.5.5-.7.7l-4.1,4.1,1.9-.8c-.8,1.6-1.2,3.5-1.2,5.4v20.5c0,7.1,5.8,12.9,12.9,12.9h12.1c1.9,0,3.6-.4,5.2-1.1l-.4,1.6,3.9-4c.3-.3.5-.5.8-.8l.2-.2h0c2-2.3,3.2-5.2,3.2-8.4v-20.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 1500.7,
    y: 63.8,
    width: 37.8,
    height: 46.3,
    rx: 12.9,
    ry: 12.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1508.5,
    y: 71.3,
    width: 22.1,
    height: 31.4,
    rx: 8,
    ry: 8
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1432.1,90.9c-6.4,0-11.5,5.2-11.5,11.5,0,6.4,5.2,11.5,11.5,11.5,6.4,0,11.5-5.2,11.5-11.5,0-2.8-1-5.4-2.7-7.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1464.7,40.5h25.8c15.7,0,28.4,12.7,28.4,28.4v23c0,21.7-17.6,39.4-39.4,39.4h-3.8c-21.7,0-39.4-17.6-39.4-39.4v-23c0-15.7,12.7-28.4,28.4-28.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1491,113.7c-5.7,2.8-12.2,2.1-17-1.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1457,
    y: 67.3,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1464.8,
    y: 75.8,
    width: 11.7,
    height: 19.6,
    rx: 5.8,
    ry: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1463.9,
    y: 72.7,
    width: 6.4,
    height: 11.7,
    rx: 3.2,
    ry: 3.2
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1457,78.2v-.2c0-5.8,4.7-10.5,10.5-10.5h0c5.8,0,10.5,4.7,10.5,10.5v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1453.5,
    y1: 74.5,
    x2: 1457.2,
    y2: 75.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1454.9,
    y1: 70.5,
    x2: 1458.4,
    y2: 72.4
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1452.6,90.1h0c7.2,0,13,5.8,13,13v2.3h-11.4c-3.6,0-6.6-3-6.6-6.6v-3.7c0-2.7,2.2-5,5-5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 1457.2,
    cy: 102.9,
    r: 7.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1496.6,
    y: 67.3,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1503.8,
    y: 75.8,
    width: 11.7,
    height: 19.6,
    rx: 5.8,
    ry: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1502.9,
    y: 72.7,
    width: 6.4,
    height: 11.7,
    rx: 3.2,
    ry: 3.2
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1517.7,78.2v-.2c0-5.8-4.7-10.5-10.5-10.5h0c-5.8,0-10.5,4.7-10.5,10.5v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1521.2,
    y1: 74.5,
    x2: 1517.4,
    y2: 75.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1519.7,
    y1: 70.5,
    x2: 1516.3,
    y2: 72.4
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1513.1,90.1h7.7v3.8c0,6.4-5.2,11.5-11.5,11.5h0v-11.5c0-2.1,1.7-3.9,3.9-3.9Z",
    transform: "translate(3029.9 195.6) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 1518.6,
    cy: 101.6,
    r: 7.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1500.4,74.3h17.6c4.1,0,7.4,3.3,7.4,7.4v3.4c0,7.9-6.4,14.4-14.4,14.4h-3.7c-7.9,0-14.4-6.4-14.4-14.4v-3.4c0-4.1,3.3-7.4,7.4-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1457.5,74.3h17.6c4.1,0,7.4,3.3,7.4,7.4v3.4c0,7.9-6.4,14.4-14.4,14.4h-3.7c-7.9,0-14.4-6.4-14.4-14.4v-3.4c0-4.1,3.3-7.4,7.4-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1482.5,83.8s1.3-2.8,5.2-2.8,5.2,3.1,5.2,3.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1488,87.5v14c0,2,1.8,3.7,4.1,3.7h2.5c3.1,0,5.1-2.9,3.7-5.4l-7.3-12.9c-.7-1.3-2.9-.8-2.9.6Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 1473.4,
    y1: 211.7,
    x2: 1473.4,
    y2: 280.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M785.1,294c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M775.3,281.8h32.9c2.4,0,4.4,2,4.4,4.4v14.1h-31c-6.2,0-11.3-5.1-11.3-11.3v-2.1c0-2.8,2.2-5,5-5Z",
    transform: "translate(1582.7 582) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 828.5,
    y: 133.5,
    width: 17.6,
    height: 14,
    transform: "translate(418.7 -598.2) rotate(50.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M814.8,174.7c5.3-4.3,6.1-12.1,1.8-17.4l-18.1-22.3c-4.3-5.3-12.1-6.1-17.4-1.8-5.3,4.3-6.1,12.1-1.8,17.4l18.1,22.3c4.3,5.3,12.1,6.1,17.4,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M815.1,174.5l23.6-19.2c1.4-1.1,1.6-3.2.5-4.6l-11.5-14.1c-1.1-1.4-3.2-1.6-4.6-.5l-23.9,19.4c-5.5,4.4-6.2,12.5-1.4,17.8,4.4,5,12.1,5.3,17.3,1.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 839.5,
    cy: 132.1,
    r: 14
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 770.2,
    y: 269.7,
    width: 29.7,
    height: 22.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M759.1,262.6c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M759.1,307.5c-7.2,0-13-5.8-13-13v-44.9c0-7.2,5.8-13,13-13s13,5.8,13,13v44.9c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M785.1,249.1c-7.2,0-13-5.8-13-13v-32c0-7.2,5.8-13,13-13s13,5.8,13,13v32c0,7.2-5.8,13-13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M765.5,183.8h13.1c10.7,0,19.4,8.7,19.4,19.4v8.1h-52v-8.1c0-10.7,8.7-19.4,19.4-19.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M774.5,194.6h4.3v9.5c0,2.4-1.9,4.3-4.3,4.3h0v-13.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M755.2,137.6h29.5c7,0,12.6,5.7,12.6,12.6v30.9c0,4.6-3.7,8.3-8.3,8.3h-38.1c-4.6,0-8.3-3.7-8.3-8.3v-30.9c0-7,5.7-12.6,12.6-12.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 758.8,
    y: 123.7,
    width: 22.7,
    height: 16.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M758.4,127.9h26.1c2.4,0,4.4,2,4.4,4.4v10.2h-34.9v-10.2c0-2.4,2-4.4,4.4-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M749.3,295.3h32.9c2.4,0,4.4,2,4.4,4.4v14.1h-31c-6.2,0-11.3-5.1-11.3-11.3v-2.1c0-2.8,2.2-5,5-5Z",
    transform: "translate(1530.7 609.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 744.2,
    y: 283.2,
    width: 29.7,
    height: 22.5,
    transform: "translate(1518.1 588.9) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 826.1,
    cy: 87.7,
    r: 14.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 736.2,
    cy: 77.6,
    r: 14.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M773.2,3.6h13.4c23.7,0,43,19.3,43,43v24.6c0,5.9-4.8,10.7-10.7,10.7h-78c-5.9,0-10.7-4.8-10.7-10.7v-24.6c0-23.7,19.3-43,43-43Z",
    transform: "translate(9.7 -87.3) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M826.2,96.4c6.3.7,10.9,6.4,10.1,12.7s-6.4,10.9-12.7,10.1-10.9-6.4-10.1-12.7,1.6-5.2,3.5-7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M735.2,86.1c-6.3-.7-12,3.8-12.7,10.1s3.8,12,10.1,12.7,12-3.8,12.7-10.1c.3-2.8-.4-5.5-1.8-7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M768.1,40.9h25.8c15.7,0,28.4,12.7,28.4,28.4v23c0,21.7-17.6,39.4-39.4,39.4h-3.8c-21.7,0-39.4-17.6-39.4-39.4v-23c0-15.7,12.7-28.4,28.4-28.4Z",
    transform: "translate(14.6 -87.2) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M795.8,112.8c1.8.2,2.8,2.2,1.7,3.7-2.9,4.2-8.1,6.7-13.5,6.1s-9.9-4.2-11.8-9,.7-3.4,2.5-3.2l21.1,2.4Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 760.9,
    y: 66.6,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5,
    transform: "translate(14 -86.1) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 768.3,
    y: 77.7,
    width: 11.7,
    height: 19.6,
    rx: 5.8,
    ry: 5.8,
    transform: "translate(14.7 -86.4) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 768.2,
    y: 74.2,
    width: 6.4,
    height: 11.7,
    rx: 3.2,
    ry: 3.2,
    transform: "translate(13.9 -86.1) rotate(6.4)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M761.4,76.3v-.2c.7-5.8,5.9-9.9,11.7-9.3h0c5.8.7,9.9,5.9,9.3,11.6v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 758.3,
    y1: 72.3,
    x2: 761.9,
    y2: 74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 760.2,
    y1: 68.5,
    x2: 763.4,
    y2: 70.7
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M754.8,88.1h0c7.2,0,13,5.8,13,13v2.3h-11.4c-3.6,0-6.6-3-6.6-6.6v-3.7c0-2.7,2.2-5,5-5Z",
    transform: "translate(15.5 -84.6) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 800.3,
    y: 71,
    width: 21,
    height: 29.5,
    rx: 10.5,
    ry: 10.5,
    transform: "translate(14.8 -90.5) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 806.7,
    y: 82.3,
    width: 11.7,
    height: 19.6,
    rx: 5.8,
    ry: 5.8,
    transform: "translate(15.5 -90.7) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 806.6,
    y: 78.9,
    width: 6.4,
    height: 11.7,
    rx: 3.2,
    ry: 3.2,
    transform: "translate(14.6 -90.4) rotate(6.4)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M821.7,83.1v-.2c.7-5.8-3.5-11-9.3-11.6h0c-5.8-.7-11,3.5-11.6,9.3v.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 825.6,
    y1: 79.9,
    x2: 821.7,
    y2: 80.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 824.6,
    y1: 75.7,
    x2: 820.9,
    y2: 77.2
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M814.9,94.6h7.7v3.8c0,6.4-5.2,11.5-11.5,11.5h0v-11.5c0-2.1,1.7-3.9,3.9-3.9Z",
    transform: "translate(1616.9 295.6) rotate(-173.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 818.9,
    cy: 106.8,
    r: 7.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 759.3,
    cy: 100.7,
    r: 7.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M803.5,78.3h17.6c4.1,0,7.4,3.3,7.4,7.4v3.4c0,7.9-6.4,14.4-14.4,14.4h-3.7c-7.9,0-14.4-6.4-14.4-14.4v-3.4c0-4.1,3.3-7.4,7.4-7.4Z",
    transform: "translate(15.3 -90.6) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M760.9,73.4h17.6c4.1,0,7.4,3.3,7.4,7.4v3.4c0,7.9-6.4,14.4-14.4,14.4h-3.7c-7.9,0-14.4-6.4-14.4-14.4v-3.4c0-4.1,3.3-7.4,7.4-7.4Z",
    transform: "translate(14.5 -85.9) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M786.1,84.8s1.6-2.7,5.5-2.2,4.9,3.6,4.9,3.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M791.1,87l-1.6,14.3c-.2,2.1,1.3,3.9,3.4,4.2l2.3.3c2.9.3,5.1-2.4,4-5.1l-5.3-13.9c-.5-1.4-2.6-1.1-2.8.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M758.7,38.1h0v86.8c0,1.6-1.3,2.9-2.9,2.9h0c-8.8,0-15.9-7.1-15.9-15.9v-55.1c0-10.3,8.4-18.7,18.7-18.7Z",
    transform: "translate(14.1 -83.6) rotate(6.4)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 765.3,
    cy: 47.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 765.2,
    cy: 42.8,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 772.7,
    cy: 41.6,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 782.9,
    cy: 37.9,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 760.1,
    cy: 57.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 759,
    cy: 67.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 758,
    cy: 76.3,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 754.9,
    cy: 103.6,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 753.8,
    cy: 112.7,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 752.8,
    cy: 121.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 756.9,
    cy: 85.4,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 755.9,
    cy: 94.5,
    r: 6.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M836.2,47.2h0c1.6,0,2.9,1.3,2.9,2.9v86.8h0c-10.3,0-18.7-8.4-18.7-18.7v-55.1c0-8.8,7.1-15.9,15.9-15.9Z",
    transform: "translate(1643.8 276.6) rotate(-173.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 823.5,
    cy: 54.4,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 817.7,
    cy: 46.7,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 808.5,
    cy: 40.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 826.5,
    cy: 64.7,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 825.3,
    cy: 74.7,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 824.3,
    cy: 83.8,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 821.2,
    cy: 111.1,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 820.2,
    cy: 120.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 819.2,
    cy: 129.3,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 823.3,
    cy: 92.9,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 822.2,
    cy: 102,
    r: 6.6
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 772.1,
    y1: 211.7,
    x2: 772.1,
    y2: 280.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M857.8,119.8l-1-1c-.6-.6-1.6-.6-2.2,0l-2.5,2.5-20,20c-.5.5-.9,1.1-1.1,1.8l-2.2,6.2,3.5,3.5,2.1-2.1,20.9-20.9,2.8-8c.2-.7,0-1.4-.4-1.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M828.7,149.9l2.4-7.4,24.1-24.1c.1-.1.4,0,.3.2l-2.5,7-24.4,24.4Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "856.2 127.8 853.3 124.9 849.7 128.5 828.9 149.3 817.7 181.2 820.6 184.1 822.7 181.9 845 159.7 856.2 127.8"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "817.7 181.2 827 151.2 853.3 124.9 842.1 156.8 817.7 181.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "820.6 176.7 830.5 148.8 850.4 128.9 840.5 156.8 820.6 176.7"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "822.8 169.7 824.9 163.3 849.8 132.4 847.7 138.9 822.8 169.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "819.2 178.9 821.4 173.5 846.9 141.9 844.4 147.6 819.2 178.9"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M845,159.7l-2.9-2.9-3.6,3.6-20.8,20.8-1.4,3.9c-.4,1.1-.1,2.4.7,3.2h0c1.2,1.2,3.1,1.2,4.3,0h0s19.1-19.1,19.1-19.1c1.2-1.2,2.1-2.6,2.6-4.2l1.9-5.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M816.3,185l1.2-3.5,24.7-24.7-1.7,4.8c-.7,2-1.8,3.7-3.3,5.2l-19.2,19.2c-.7.7-2,0-1.6-1Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 843,
    cy: 131.8,
    rx: 0.8,
    ry: 0.3,
    transform: "translate(174.8 662.4) rotate(-47.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 844.5,
    cy: 131.3,
    rx: 0.8,
    ry: 0.3,
    transform: "translate(175.6 663.4) rotate(-47.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 843.6,
    cy: 133.2,
    rx: 0.8,
    ry: 0.3,
    transform: "translate(173.9 663.3) rotate(-47.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 842.1,
    cy: 133.6,
    rx: 0.8,
    ry: 0.3,
    transform: "translate(173.2 662.3) rotate(-47.3)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 833.5,
    cy: 166.6,
    rx: 0.9,
    ry: 0.4,
    transform: "translate(146.2 666.6) rotate(-47.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 835.3,
    cy: 166.1,
    rx: 0.9,
    ry: 0.4,
    transform: "translate(147.1 667.8) rotate(-47.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 834.2,
    cy: 168.3,
    rx: 0.9,
    ry: 0.4,
    transform: "translate(145.2 667.7) rotate(-47.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 832.4,
    cy: 168.8,
    rx: 0.9,
    ry: 0.4,
    transform: "translate(144.2 666.5) rotate(-47.3)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-33",
    cx: 829.1,
    cy: 172.1,
    rx: 2.3,
    ry: 1,
    transform: "translate(140.7 665.1) rotate(-47.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 828.4,
    cy: 171.4,
    rx: 2.3,
    ry: 1,
    transform: "translate(141 664.4) rotate(-47.3)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 848.1,
    cy: 127.8,
    rx: 2.5,
    ry: 1.1,
    transform: "translate(179.4 664.8) rotate(-47.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 847.3,
    cy: 127,
    rx: 2.5,
    ry: 1.1,
    transform: "translate(179.7 664) rotate(-47.3)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M842.3,165l-1.7-1.6,1.7-5,.6-.4,1.6,1.6s-1.1,3.3-1.3,4.1c-.4,1.2-.8,1.3-.8,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M840.6,163.3l1.7-5,.6-.4s-1.1,3.3-1.3,4.1c-.3,1.1-.9,1.3-.9,1.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M855.8,126.5l-1.7-1.6,1.9-5.7,1.4,1.4c.3.3.4.8.3,1.2l-1.4,4.3-.6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M854.2,124.9l1.9-5.7s.4.3.2.9-1.5,4.4-1.5,4.4l-.6.4Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "855.8 126.5 854.2 124.9 854.8 124.4 856.4 126.1 855.8 126.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 805.6,
    y: 178,
    width: 17.6,
    height: 14,
    transform: "translate(629.5 999.4) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M784.1,193.5c-4.8,4.8-12.7,4.8-17.5,0l-20.3-20.3c-4.8-4.8-4.8-12.7,0-17.5s12.7-4.8,17.5,0l20.3,20.3c4.8,4.8,4.8,12.7,0,17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M775.8,172.6h30.4c1.8,0,3.2,1.5,3.2,3.2v18.2c0,1.8-1.5,3.2-3.2,3.2h-30.8c-7,0-12.7-5.9-12.3-13s6-11.8,12.7-11.8Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 821.1,
    cy: 179.8,
    r: 14
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1525.3,60.2v-5.2c0-19.6-15.9-35.6-35.6-35.6h-9.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1448.6,75c0-7.1-5.8-12.9-12.9-12.9h-12.1c-3.3,0-6.3,1.2-8.5,3.3h0s-.2.2-.2.2c-.3.2-.5.5-.7.7l-4.1,4.1,1.9-.8c-.8,1.6-1.2,3.5-1.2,5.4v20.5c0,7.1,5.8,12.9,12.9,12.9h12.1c1.9,0,3.6-.4,5.2-1.1l-.4,1.6,3.9-4c.3-.3.5-.5.8-.8l.2-.2h0c2-2.3,3.2-5.2,3.2-8.4v-20.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1406.2,
    y: 66.7,
    width: 37.8,
    height: 46.3,
    rx: 12.9,
    ry: 12.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1414,
    y: 74.2,
    width: 22.1,
    height: 31.4,
    rx: 8,
    ry: 8
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1425.3,87.3v-31.1c0-20.3,16.5-36.8,36.8-36.8h27.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1455.1,41.3h0v86.8c0,1.6-1.3,2.9-2.9,2.9h0c-8.8,0-15.9-7.1-15.9-15.9v-55.1c0-10.3,8.4-18.7,18.7-18.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1457.7,
    cy: 49.4,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1457,
    cy: 44.5,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1464.3,
    cy: 42.5,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1474.1,
    cy: 37.6,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1453.6,
    cy: 59.3,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1453.6,
    cy: 69.4,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1453.6,
    cy: 78.6,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1453.6,
    cy: 106.1,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1453.6,
    cy: 115.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1453.6,
    cy: 124.4,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1453.6,
    cy: 87.7,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1453.6,
    cy: 96.9,
    r: 6.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1533.1,41.3h0c1.6,0,2.9,1.3,2.9,2.9v86.8h0c-10.3,0-18.7-8.4-18.7-18.7v-55.1c0-8.8,7.1-15.9,15.9-15.9Z",
    transform: "translate(3053.2 172.3) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1516.2,
    cy: 49.4,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1509.6,
    cy: 42.5,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1499.8,
    cy: 37.6,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1520.3,
    cy: 59.3,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1520.3,
    cy: 69.4,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1520.3,
    cy: 78.6,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1520.3,
    cy: 106.1,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1520.3,
    cy: 115.2,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1520.3,
    cy: 124.4,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1520.3,
    cy: 87.7,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1520.3,
    cy: 96.9,
    r: 6.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 1516.2,
    cy: 44.5,
    r: 4.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 1423.4,
    y: 96.1,
    width: 17.6,
    height: 14,
    transform: "translate(2517.8 -836.7) rotate(135)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1459.8,118.7c6.8,0,12.4,5.5,12.4,12.4v28.7c0,6.8-5.5,12.4-12.4,12.4-6.8,0-12.4-5.5-12.4-12.4v-28.7c0-6.8,5.5-12.4,12.4-12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1450.8,139.2l-21.5-21.5c-1.3-1.3-1.3-3.3,0-4.6l12.9-12.9c1.3-1.3,3.3-1.3,4.6,0l21.8,21.8c5,5,4.8,13.1-.4,17.9-4.9,4.5-12.6,4-17.3-.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 1430.9,
    cy: 94.5,
    r: 14
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1424.3,15.1l1.6,21.8,22.9-13.2-18.1-12.3c-2.9-2-6.7.3-6.5,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1429.5,20.4l.4,7.7c0,1.7,2,2.8,3.5,1.9l6.1-3.5c1.5-.9,1.6-3,0-4l-6.5-4.2c-1.6-1-3.7.2-3.6,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1524.9,10.8l-19.9,8.9,20.3,17.1,5.4-21.2c.9-3.4-2.6-6.2-5.7-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1521.8,17.9l-6.7,3.8c-1.5.9-1.6,3-.1,4l5.9,3.8c1.5.9,3.4,0,3.6-1.7l.7-7.7c.2-1.9-1.8-3.2-3.5-2.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlyssia1);
export default __webpack_public_path__ + "static/media/alyssia_1.4a4330333031150ae8c1bde546e5c206.svg";
export { ForwardRef as ReactComponent };